import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '../../app/api/apiSlice'

const userSetupStatussAdapter = createEntityAdapter({})

const initialState = userSetupStatussAdapter.getInitialState()

export const userSetupStatussApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserSetupStatuss: builder.query({
            query: () => ({
                url: '/userSetupStatuss/getUserSetupStatuss',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserSetupStatuss = responseData.map(userSetupStatus => {
                    userSetupStatus.id = userSetupStatus._id
                    return userSetupStatus
                })
                return userSetupStatussAdapter.setAll(initialState, loadedUserSetupStatuss)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserSetupStatus', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserSetupStatus', id}))
                    ]
                } else {
                    return [ { type: 'UserSetupStatus', id: 'LIST'}]
                }
            },
        }),
        createNewUserSetupStatus: builder.mutation({
            query: initialUserSetupStatus => ({
                url: '/userSetupStatuss',
                method: 'POST',
                body: {...initialUserSetupStatus,}
            }),
            invalidatesTags: [
                { type: 'UserSetupStatus', id: "LIST" }
            ] 
        }),
        updateUserSetupStatus: builder.mutation({
            query: initialUserSetupStatus => ({
                url: '/userSetupStatuss',
                method: 'PATCH',
                body: {...initialUserSetupStatus,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserSetupStatus', id: arg.id },
                { type: 'UserSetupStatus', id: 'LIST' }
            ],
        }),
        deleteUserSetupStatus: builder.mutation({
            query: ({id}) => ({
                url: '/userSetupStatuss',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserSetupStatus', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserSetupStatussQuery,
    useCreateNewUserSetupStatusMutation,
    useUpdateUserSetupStatusMutation,
    useDeleteUserSetupStatusMutation,
} = userSetupStatussApiSlice

// returns the query result object
export const selectUserSetupStatusResult = userSetupStatussApiSlice.endpoints.getUserSetupStatuss.select()

// create memoized selector
const selectUserSetupStatussData = createSelector(
    selectUserSetupStatusResult,
    userSetupStatusResult => userSetupStatusResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserSetupStatuss,
    selectById: selectUserSetupStatusById,
    selectIds: selectUserSetupStatusIds,
} = userSetupStatussAdapter.getSelectors(state => selectUserSetupStatussData(state) ?? initialState)